import {environment} from '../../environments/environment';
import {Injectable} from '@angular/core';



@Injectable({
  providedIn: 'root'
})
export class CommandUtil
{

  public static chuaPhoCap: number = 0;
  public static daPhoCap: number = 1;
  public static defaultValue: number = -1;

  public getUrlDownload(folder: string, fileName: string, fileType: string, title: string): string
  { return environment.downloadURL + `file=${folder}${fileName}&type=${fileType}&title=${title}&auth=Bearer ${sessionStorage.getItem('token')}`;
  }
  public getUrlAvatar(file: string): string
  {
    if(file===null)
      return 'assets/img/avatars/1.jpg';
    return environment.downloadURL + `file=${file}&type=image/jpg&title=avatar&auth=Bearer ${sessionStorage.getItem('token')}`;
  }
  public static formatDate(date: Date): Date
  {
    return  new Date(date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate());
  }
  public getDate(strDate : string)
  {
    try {
      let arr : string[] = strDate.split('/');
      if(arr.length>=3) {
        return new Date(Date.parse(arr[1] + "/" + arr[0] + "/" + arr[2]));
      }
    }catch (e) {
        console.log(e.toString());
    }

    return new Date();
  }
  public removeItem(element: number, dataCheck: Object[]) {
    dataCheck.forEach((value, index) => {
      if(value == element) dataCheck.splice(index,1);
    });
  }
  public getSizeFile(size: number): string
  {
    let iSize = (size / 1024);
    iSize = (Math.round(iSize * 100) / 100);
    return iSize  + "KB";
  }
  public formatAlert(first: string , last: string, value: string ): string
  {
      let temp: string = value;
      if (first !== null && first !== '')
          temp =  first;
      if (last !== null && last !== '')
        temp =  temp + ' - ' + last;
    return temp;
  }
  public zipFiles(fileName: string, url: Object []) : string {

    let pathFile  = "";
    let nameFile  = "";
    let titleFile = "";
    for(let i = 0 ; i < url.length ; i++)
    {
      pathFile += url[i]["folder"] + ',';
      nameFile += url[i]["fileKey"] +',';
      titleFile += url[i]["name"] +',';
    }
    return environment.downloadZipURL + `pathfile=${pathFile}&filename=${nameFile}&filetitle=${titleFile}&title=${fileName}&auth=Bearer ${sessionStorage.getItem('token')}`;
  }

}
